import { PropsWithChildren, ReactNode } from 'react';

import { TagHolder, TagPrefixHolder, TagText } from './Tag.styled';

type Props = {
  qaId?: string;
  prefix?: ReactNode;
  size?: 'micro' | 'small' | 'large';
  variant?: 'default' | 'danger';
  className?: string;
};

export function Tag({
  children,
  qaId,
  prefix,
  size = 'small',
  variant = 'default',
  className,
}: PropsWithChildren<Props>) {
  return (
    <TagHolder
      data-variant={variant}
      data-size={size}
      data-qa-id={qaId}
      className={className}
    >
      <TagPrefixHolder>{prefix}</TagPrefixHolder>
      <TagText>{children}</TagText>
    </TagHolder>
  );
}
